import type { StreamProvider } from '@vgtv/api-client';

export const countryMap: Record<string, (StreamProvider | 'brandstudio')[]> = {
  no: ['vgtv', 'ap', 'bt', 'e24', 'sa', 'brandstudio', 'vgtts'],
  se: ['ab', 'svd', 'abtts'],
};
